import { render, staticRenderFns } from "./AnalysesBadge.vue?vue&type=template&id=5781785f&scoped=true&"
import script from "./AnalysesBadge.vue?vue&type=script&lang=ts&"
export * from "./AnalysesBadge.vue?vue&type=script&lang=ts&"
import style0 from "./analyses-badge.scss?vue&type=style&index=0&id=5781785f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781785f",
  null
  
)

export default component.exports